import {InlineLink, Text} from '@primer/react-brand/esm'
import {clsx} from 'clsx'

import {linkClickAnalytics} from '../../utils/analytics'
import {CloseButton} from '../CloseButton/CloseButton'
import styles from './DefaultBanner.module.css'
import type {BannerDescriptor} from '../../marketing-global-banner.types'

export function DefaultBanner({banner}: {banner: BannerDescriptor}) {
  const {uid, title, link, link_label, icon: Icon, background} = banner

  return (
    <div className={clsx(styles.banner, background === 'muted' && styles.bannerMuted)}>
      {Icon ? <Icon className={styles.icon} /> : null}
      {title ? (
        <Text as="span" size="100" className={styles.title}>
          {title}
        </Text>
      ) : null}
      <InlineLink href={link} className={styles.link} data-analytics-event={linkClickAnalytics(uid, title)}>
        {link_label}
      </InlineLink>
      <CloseButton uid={uid} wrapperClassName={styles.closeWrapper} buttonClassName={styles.close} />
    </div>
  )
}
